export default "__VITE_ASSET__dabcccb3__"